const routes = {
  login: '/login',
  changePassword: '/change-password',
  dashboard: '/',
};

export default routes;
